module.exports = __webpack_public_path__ + "static/media/logo4.7fde869b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo4.png
// module id = 131
// module chunks = 0